import { useEffect, useState } from "react";
import axios from "axios";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

function Gallery() {
  const [galleryItems, setGalleryItems] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/gallery/`)
      .then(res => {
	const formatted = res.data.map(img => ({
          original: img.image,
          thumbnail: img.image,
          description: img.title || "",
        }));
        setGalleryItems(formatted);
      })
      .catch(err => console.error("Failed to fetch gallery images:", err));
  }, []);

  return (
    <div className="max-w-5xl mx-auto py-10 px-4">
      <h2 className="text-4xl font-bold text-center text-black mb-6">Gallery</h2>
      <ImageGallery
        items={galleryItems}
        showFullscreenButton={true}
        showPlayButton={true}
        showThumbnails={true}
        thumbnailPosition="bottom"
        slideInterval={5000}
        autoPlay={true}
      />
    </div>
  );
}

export default Gallery;
